import styles from "../../styles/Navigation.module.css";

export default function QuestionGrid({ questionCount, handleQuestion, activeQuestion, isAnswered, section, stage, handleStage }) {
    const getQuestionRanges = () => {
        if (section === "listening") {
            return [
                { part: 1, start: 1, end: 10, label: "Part 1:" },
                { part: 2, start: 11, end: 20, label: "Part 2:" },
                { part: 3, start: 21, end: 30, label: "Part 3:" },
                { part: 4, start: 31, end: 40, label: "Part 4:" }
            ];
        } else if (section === "reading") {
            return [
                { part: 1, start: 1, end: 13, label: "Part 1" },
                { part: 2, start: 14, end: 26, label: "Part 2" },
                { part: 3, start: 27, end: 40, label: "Part 3" }
            ];
        }
        return [];
    };

    const questionRanges = getQuestionRanges();

    const renderPart = (partData) => {
        const { part, start, end, label } = partData;
        const isCurrentPart = stage === part;
        const totalQuestions = end - start + 1;
        const answeredCount = Array.from({ length: totalQuestions }, (_, index) => {
            const questionNumber = start + index;
            return isAnswered(questionNumber);
        }).filter(Boolean).length;

        const showIndividualQuestions = isCurrentPart;

        return (
            <div onClick={() => handleStage(part)} key={part} className={`${styles.partContainer} ${isCurrentPart ? styles.currentPart : styles.partContainerHover}`}>
                <button
                    className={`${styles.partLabel} ${isCurrentPart ? styles.currentPartLabel : ""}`}

                >
                    {label}
                </button>

                {showIndividualQuestions ? (
                    <>
                        {/* <div className={styles.progressBar}></div> */}
                        <div className={styles.questionsContainer}>
                            {Array.from({ length: totalQuestions }, (_, index) => {
                                const questionNumber = start + index;
                                const questionAnswered = isAnswered(questionNumber);

                                return (
                                    <button
                                        key={questionNumber}
                                        onClick={() => handleQuestion(questionNumber)}
                                        className={`${styles.questionButton} ${activeQuestion === questionNumber ? styles.active : ""
                                            } ${questionAnswered ? styles.answered : ""}`}
                                    >
                                        {questionNumber}
                                    </button>
                                );
                            })}
                        </div>
                    </>
                ) : (
                    <div className={styles.partSummary}>
                        {answeredCount} of {totalQuestions}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className={styles.ieltsNavigation}>
            {questionRanges.map(renderPart)}
        </div>
    );
}
